// extracted by mini-css-extract-plugin
export var badge = "_sa-4";
export var selected = "_sa-1";
export var selectedOverlay = "_sa-5";
export var thumbnailButton = "_sa-0";
export var thumbnailFallback = "_sa-3";
export var thumbnailImage = "_sa-2";